import Head from 'next/head';
import {ReactElement} from 'react';
import {useHref} from '@sail/navigation';
import {usePageMetadata} from 'mkt-ssr/lib/page/metadata';

const DEFAULT_SOCIAL_CARD_IMAGE =
  'https://images.stripeassets.com/fzn2n1nzq965/3AGidihOJl4nH9D1vDjM84/9540155d584be52fc54c443b6efa4ae6/homepage.png?h=250&q=80';

/**
 * Generates the various social media SEO tags for stripe.com
 */
export const SocialMetaTags = (): ReactElement => {
  const {analytics, social} = usePageMetadata();
  const [currentUrlPath] = useHref();
  const currentUrl = `https://stripe.com${currentUrlPath}`;

  const description = social?.description || '';
  const image = social?.image || DEFAULT_SOCIAL_CARD_IMAGE;

  return (
    <Head>
      {description ? <meta name="description" content={description} /> : null}

      <meta property="og:title" content={analytics.title} />
      {description ? (
        <meta property="og:description" content={description} />
      ) : null}
      <meta property="og:image" content={image} />
      <meta property="og:url" content={currentUrl} />
      <meta property="og:type" content="website" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:site" content="@stripe" />
      <meta name="twitter:title" content={analytics.title} />
      {description ? (
        <meta name="twitter:description" content={description} />
      ) : null}
      <meta name="twitter:image" content={image} />

      <meta
        name="facebook-domain-verification"
        content="zvsnguqc5l0xz3at5o9beubpl46dv8"
      />
    </Head>
  );
};
